import styles from './SubmittedContent.module.scss'

import React from 'react'

class SubmittedContent extends React.Component {
  render () {
    return (
      <div className={styles.wrapper}>
        <span className={styles.successMessage}>
          Obrigado.
          <br />
          Entraremos em contacto assim que possível.
        </span>
      </div>
    )
  }
}

export default SubmittedContent
